import { render, staticRenderFns } from "./EducationMastersDetails.vue?vue&type=template&id=733cd667&scoped=true"
import script from "./EducationMastersDetails.vue?vue&type=script&lang=js"
export * from "./EducationMastersDetails.vue?vue&type=script&lang=js"
import style0 from "./EducationMastersDetails.vue?vue&type=style&index=0&id=733cd667&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733cd667",
  null
  
)

export default component.exports